import React, { Component } from 'react'
import ReactGA from 'react-ga'
import axios from 'axios'

import './styles.css'

import imgLogo from '../../assets/images/logo.svg'
import imgCoin from '../../assets/images/coin.png'
import imgPlay from '../../assets/images/play.svg'

class LuckySix extends Component {

  constructor (props) {
    super(props)

    this.state = {
      lastDrawing: [],
      nextDrawingCount: '',
    }
  }

  componentDidMount () {
    ReactGA.pageview('/lucky6')

    axios.post('https://us-central1-lucky-miner.cloudfunctions.net/getLastCoins').then(res => {
      this.setState({
        lastDrawing: res.data,
      })
    })
    .catch(err => {
      console.log(err)
    })

    axios.post('https://us-central1-lucky-miner.cloudfunctions.net/getNextDrawing').then(res => {
      this.setState({
        nextDrawingCount: res.data,
      })
    })
    .catch(err => {
      console.log(err)
    })
  }

  onDownload = () => {
    ReactGA.event({
      category: 'Interaction',
      action: 'Download Clicked',
      label: 'Download'
    })
  }

  onWinners = () => {
    this.props.history.push('/winners')
  }

  onFAQ = () => {
    this.props.history.push('/')
  }

  render () {
    const coins = this.state.lastDrawing.map(((coin, index) => {
      return <div key={ index } className='div-coin'><img src={ imgCoin } alt='coin'/><span>{ coin }</span></div>
    }))

    return (
      <div className='div-luckysix-container'>
        <div className='div-buttons'>
          <span className='clickable' onClick={ this.onWinners }>WINNERS</span>
          <span className='clickable' onClick={ this.onFAQ }>FAQ</span>
        </div>
        
        <div className='div-center'>
          <img className='img-logo' src={imgLogo} alt='logo'/>
          <div className='div-description'> 
            WEEKLY DRAWING OF THE LUCKY 6 
          </div>
          <div className='div-coins'>
            { coins }
          </div>
        </div>

        <div className='div-countdown'>
          NEXT DRAWING: 
          <span>{ ' ' + this.state.nextDrawingCount }</span>
          <a href='/Little Miner.zip' download><img className='img-play clickable' src={imgPlay} alt='play' onClick={this.onDownload}/></a>
        </div>
      </div>
    )
  }
}

export default LuckySix



// WEBPACK FOOTER //
// ./src/containers/LuckySix/index.js